(function () {
  'use strict';

  function ready(callback) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback);
    else callback();
  }

  function initFlow(root) {
    var form = root.querySelector('[data-contact-form]');
    var success = root.querySelector('[data-contact-success]');
    if (success) {
      window.requestAnimationFrame(function () { success.focus(); });
      return;
    }
    if (!form || root.classList.contains('contact-flow--enhanced')) return;

    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-step]'));
    var back = root.querySelector('[data-contact-back]');
    var count = root.querySelector('[data-contact-count]');
    var progress = root.querySelector('[data-contact-progress]');
    var announcer = root.querySelector('[data-contact-announcer]');
    var summary = root.querySelector('[data-contact-summary]');
    var bodyField = root.querySelector('[data-contact-body]');
    var subjectField = root.querySelector('[data-contact-subject]');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var currentIndex = 0;
    var advanceTimer;

    var routes = {
      compatibility: ['purpose', 'compat-product', 'vehicle', 'compat-specific', 'contact', 'review'],
      prepurchase: ['purpose', 'pre-product', 'pre-subject', 'pre-question', 'contact', 'review'],
      order: ['purpose', 'order-number', 'order-action', 'order-details', 'contact', 'review'],
      return: ['purpose', 'order-number', 'return-reason', 'return-state', 'contact', 'review'],
      support: ['purpose', 'support-product', 'support-vehicle', 'support-issue', 'support-description', 'contact', 'review'],
      professional: ['purpose', 'pro-type', 'pro-identity', 'pro-proposal', 'contact', 'review'],
      other: ['purpose', 'other-message', 'contact', 'review']
    };

    function checked(selector) {
      return form.querySelector(selector + ':checked');
    }

    function selectedRoute() {
      var choice = checked('input[data-route]');
      return choice ? choice.getAttribute('data-route') : '';
    }

    function selectedProduct() {
      var compat = checked('input[name="contact[Produit - compatibilité]"]');
      var prepurchase = checked('input[name="contact[Produit - avant achat]"]');
      if (selectedRoute() === 'prepurchase' && prepurchase) return prepurchase.getAttribute('data-product') || 'unknown';
      return compat ? compat.getAttribute('data-product') || 'unknown' : (prepurchase ? prepurchase.getAttribute('data-product') || 'unknown' : 'unknown');
    }

    function currentSequence() {
      var route = selectedRoute();
      var sequence = routes[route] ? routes[route].slice() : ['purpose'];
      if (route === 'prepurchase') {
        var subject = checked('input[name="contact[Sujet avant achat]"]');
        if (subject && subject.getAttribute('data-subject') === 'compatibility') {
          sequence = ['purpose', 'pre-product', 'pre-subject', 'vehicle', 'compat-specific', 'contact', 'review'];
        }
      }
      return sequence;
    }

    function setProductPanels() {
      var product = selectedProduct();
      root.querySelectorAll('[data-product-panel]').forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-product-panel') !== product;
      });
    }

    function controlIsRelevant(control, sequence) {
      var step = control.closest('[data-step]');
      if (step && sequence.indexOf(step.getAttribute('data-step')) === -1) return false;
      var productPanel = control.closest('[data-product-panel]');
      return !productPanel || !productPanel.hidden;
    }

    function syncControls(sequence) {
      steps.forEach(function (step) {
        step.querySelectorAll('input, textarea, select, button').forEach(function (control) {
          if (control.type === 'button' || control.type === 'submit') return;
          control.disabled = !controlIsRelevant(control, sequence);
        });
      });
      if (bodyField) bodyField.disabled = false;
      if (subjectField) subjectField.disabled = false;
    }

    function clearError(step) {
      var error = step.querySelector('[data-step-error]');
      if (error) error.textContent = '';
      step.querySelectorAll('[aria-invalid="true"]').forEach(function (field) { field.removeAttribute('aria-invalid'); });
    }

    function setError(step, message, field) {
      var error = step.querySelector('[data-step-error]');
      if (error) error.textContent = message;
      if (field) {
        field.setAttribute('aria-invalid', 'true');
        field.focus();
      }
      if (announcer) announcer.textContent = message;
    }

    function activeControls(step) {
      return Array.prototype.slice.call(step.querySelectorAll('input:not(:disabled), textarea:not(:disabled), select:not(:disabled)'));
    }

    function validateStep(step) {
      clearError(step);
      var controls = activeControls(step);
      var visibleRadios = controls.filter(function (control) { return control.type === 'radio'; });
      if (visibleRadios.length && !visibleRadios.some(function (radio) { return radio.checked; })) {
        setError(step, 'Choisissez une option pour continuer.', visibleRadios[0]);
        return false;
      }

      for (var i = 0; i < controls.length; i += 1) {
        var control = controls[i];
        var needsValue = control.hasAttribute('data-required') || control.required;
        if (needsValue && !String(control.value || '').trim()) {
          setError(step, 'Renseignez ce champ pour continuer.', control);
          return false;
        }
        if (control.value && typeof control.checkValidity === 'function' && !control.checkValidity()) {
          var message = control.type === 'email'
            ? 'Saisissez une adresse e-mail valide.'
            : (control.type === 'url' ? 'Saisissez une adresse complète, commençant par https://.' : 'Vérifiez la valeur indiquée.');
          setError(step, message, control);
          return false;
        }
      }
      return true;
    }

    function valueFor(control) {
      if ((control.type === 'radio' || control.type === 'checkbox') && !control.checked) return '';
      return String(control.value || '').trim();
    }

    function summaryEntries(sequence) {
      var entries = [];
      var used = {};
      steps.forEach(function (step) {
        if (sequence.indexOf(step.getAttribute('data-step')) === -1) return;
        step.querySelectorAll('[data-summary]:not(:disabled)').forEach(function (control) {
          if (!controlIsRelevant(control, sequence)) return;
          var value = valueFor(control);
          var label = control.getAttribute('data-summary');
          if (!value || !label || used[label]) return;
          used[label] = true;
          entries.push({ label: label, value: value });
        });
      });
      return entries;
    }

    function buildSubmission(sequence) {
      var entries = summaryEntries(sequence);
      if (summary) {
        summary.replaceChildren();
        entries.forEach(function (entry) {
          var row = document.createElement('div');
          var term = document.createElement('dt');
          var description = document.createElement('dd');
          term.textContent = entry.label;
          description.textContent = entry.value;
          row.appendChild(term);
          row.appendChild(description);
          summary.appendChild(row);
        });
      }
      if (bodyField) {
        var lines = ['DEMANDE ROADNEST', ''];
        entries.forEach(function (entry) { lines.push(entry.label + ' : ' + entry.value); });
        bodyField.value = lines.join('\n');
      }
      if (subjectField) {
        var category = entries.find(function (entry) { return entry.label === 'Catégorie'; });
        subjectField.value = category ? 'Demande Roadnest — ' + category.value : 'Demande Roadnest';
      }
    }

    function focusStep(step) {
      var heading = step.querySelector('[data-step-title]');
      if (!heading) return;
      window.requestAnimationFrame(function () {
        heading.focus({ preventScroll: true });
        heading.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
      });
    }

    function showStep(shouldFocus) {
      window.clearTimeout(advanceTimer);
      setProductPanels();
      var sequence = currentSequence();
      if (currentIndex > sequence.length - 1) currentIndex = sequence.length - 1;
      var currentId = sequence[currentIndex];
      var currentStep;

      steps.forEach(function (step) {
        var isCurrent = step.getAttribute('data-step') === currentId;
        step.hidden = !isCurrent;
        if (isCurrent) currentStep = step;
      });
      syncControls(sequence);
      if (currentId === 'review') buildSubmission(sequence);
      var displayedTotal = selectedRoute() ? sequence.length : 6;
      if (back) back.disabled = currentIndex === 0;
      if (count) count.textContent = 'Étape ' + (currentIndex + 1) + ' sur ' + displayedTotal;
      if (progress) progress.style.width = (((currentIndex + 1) / displayedTotal) * 100) + '%';
      if (announcer && currentStep) {
        var title = currentStep.querySelector('[data-step-title]');
        announcer.textContent = 'Étape ' + (currentIndex + 1) + ' sur ' + displayedTotal + (title ? ' : ' + title.textContent.trim() : '');
      }
      if (shouldFocus !== false && currentStep) focusStep(currentStep);
    }

    function nextStep() {
      var sequence = currentSequence();
      var id = sequence[currentIndex];
      var step = steps.find(function (item) { return item.getAttribute('data-step') === id; });
      if (!step || !validateStep(step)) return;
      sequence = currentSequence();
      if (currentIndex < sequence.length - 1) currentIndex += 1;
      showStep(true);
    }

    root.classList.add('contact-flow--enhanced');
    if (bodyField) bodyField.required = false;
    setProductPanels();
    showStep(false);

    form.addEventListener('change', function (event) {
      var choice = event.target.closest('input[type="radio"]');
      if (!choice) return;
      clearError(choice.closest('[data-step]'));
      setProductPanels();
      showStep(false);
      if (choice.hasAttribute('data-auto')) {
        window.clearTimeout(advanceTimer);
        advanceTimer = window.setTimeout(nextStep, reduceMotion.matches ? 0 : 180);
      }
    });

    form.addEventListener('click', function (event) {
      var next = event.target.closest('[data-contact-next]');
      var modify = event.target.closest('[data-contact-modify]');
      if (next) {
        event.preventDefault();
        nextStep();
      }
      if (modify) {
        event.preventDefault();
        currentIndex = 0;
        showStep(true);
      }
    });

    form.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' || event.shiftKey || event.isComposing) return;
      var target = event.target;
      if (!target.matches('input:not([type="radio"]):not([type="checkbox"]):not([type="submit"])')) return;
      event.preventDefault();
      nextStep();
    });

    if (back) {
      back.addEventListener('click', function () {
        if (currentIndex > 0) currentIndex -= 1;
        showStep(true);
      });
    }

    form.addEventListener('submit', function (event) {
      var sequence = currentSequence();
      if (sequence[currentIndex] !== 'review') {
        event.preventDefault();
        nextStep();
        return;
      }

      for (var i = 0; i < sequence.length - 1; i += 1) {
        var step = steps.find(function (item) { return item.getAttribute('data-step') === sequence[i]; });
        if (step && !validateStep(step)) {
          event.preventDefault();
          currentIndex = i;
          showStep(false);
          focusStep(step);
          return;
        }
      }
      buildSubmission(sequence);
      var submit = form.querySelector('[type="submit"]');
      if (submit) {
        submit.disabled = true;
        submit.textContent = 'ENVOI EN COURS…';
      }
    });

    var shopifyErrors = root.querySelector('[data-shopify-errors]');
    if (shopifyErrors) shopifyErrors.focus();
  }

  ready(function () {
    document.querySelectorAll('[data-contact-flow]').forEach(initFlow);
  });
})();
